import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function WhatsAppButton() {
  const [num, setNum] = useState("");
  useEffect(() => {
    api.get("/content").then(({ data }) => setNum(data?.whatsapp_number || "")).catch(() => {});
  }, []);
  if (!num) return null;
  const link = `https://wa.me/${num.replace(/\D/g, "")}?text=${encodeURIComponent("Olá! Vim pelo site da Duo Áurea e gostaria de tirar uma dúvida.")}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgb(0,0,0,0.15)] flex items-center justify-center hover:scale-105 transition-transform"
      data-testid="whatsapp-float-button"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle size={24} />
    </a>
  );
}
